<template>
  <div class="animated fadeIn vld-parent custom-100">
    <b-row style="background-color: #FBFBFB; padding-left: 4px; padding-right: 15px; padding-top: 8px; padding-bottom: 8px">
        <div style="margin-left: 15px">
          <!--b-button-group style="margin-right: 12px">
            <b-button style="padding-left: 0px;" @click="buttonState === 'none' ? selectState('all') : selectState('none')">
              <checkbox
                  title=""
                  v-if="buttonState === 'none'"
                  v-tooltip="'Alle wählen'"
                  class="icon-1_5x icon-def-grey" fillColor="#383838" style="margin-left: -4px" :size="72"></checkbox>
              <checkbox-checked
                  title=""
                  v-if="buttonState === 'all'"
                  v-tooltip="'Abwählen'"
                  class="icon-1_5x icon-def-grey" fillColor="#383838" style="margin-left: -4px" :size="72"></checkbox-checked>
              <checkbox-some
                  title=""
                  v-if="buttonState === 'some'"
                  v-tooltip="'Abwählen'"
                  class="icon-1_5x icon-def-grey" fillColor="#383838" style="margin-left: -4px" :size="72"></checkbox-some>
            </b-button>
            <b-dropdown text="">
              <b-dropdown-item @click="selectState('all')">Alle</b-dropdown-item>
              <b-dropdown-item @click="selectState('none')">Keine</b-dropdown-item>
              <b-dropdown-item @click="selectState('read')">Gelesen</b-dropdown-item>
              <b-dropdown-item @click="selectState('unread')">Ungelesen</b-dropdown-item>
              <b-dropdown-item @click="selectState('marked')">Markiert</b-dropdown-item>
              <b-dropdown-item @click="selectState('unmarked')">Nicht markiert</b-dropdown-item>
            </b-dropdown>
          </b-button-group-->
          <b-button-group style="margin-right: 12px">
            <b-dropdown text="">
              <template #button-content="scope">
                <set-read
                    v-if="isRead === 0"
                    title=""
                    class="icon-1_5x icon-def-grey" fillColor="#383838" style="margin-left: -14px" :size="72"></set-read>
                <set-unread
                    v-else-if="isRead === 1"
                    title=""
                    class="icon-1_5x icon-def-grey" fillColor="#383838" style="margin-left: -14px" :size="72"></set-unread>
                <all-mail
                    v-else
                    title=""
                    class="icon-1_5x icon-def-grey" fillColor="#383838" style="margin-left: -14px" :size="72"></all-mail>
                <span style="margin-left: 18px; margin-right: 10px; vertical-align: inherit" class="header-button">{{filterTitleIsRead}}</span>
              </template>
              <b-dropdown-item @click="isRead = -1; page = 0; queryData(false)">Alle</b-dropdown-item>
              <b-dropdown-item @click="isRead = 0; page = 0; queryData(false)">Ungelesen</b-dropdown-item>
              <b-dropdown-item @click="isRead = 1; page = 0; queryData(false)">Gelesen</b-dropdown-item>
            </b-dropdown>
          </b-button-group>
          <refresh
              title=""
              v-if="buttonState === 'none'"
              v-tooltip="'Neu laden'"
              @click="manualRefresh"
              class="icon-1_5x icon-def-grey" fillColor="#383838" style="vertical-align: middle; margin: 6px; cursor: pointer" :size="72"></refresh>
          <set-read
              title=""
              v-if="buttonState !== 'none'"
              @click="handleChangeMessage(selectedItems, true, opRead)"
              v-tooltip="'Als gelesen markieren'"
              class="icon-1_5x" fillColor="#016d03" :size="72" style="color:#6e6e6e; vertical-align: middle; margin: 6px; cursor: pointer"></set-read>
          <set-unread
              title=""
              @click="handleChangeMessage(selectedItems, false, opRead)"
              v-if="buttonState !== 'none'"
              v-tooltip="'Als ungelesen markieren'"
              class="icon-1_5x" fillColor="#016d03" :size="72" style="color:#6e6e6e; vertical-align: middle; margin: 6px; cursor: pointer"></set-unread>
          <delete
              title=""
              @click="handleChangeMessage(selectedItems, true, opDelete)"
              v-if="buttonState !== 'none'"
              v-tooltip="'Löschen'"
              class="icon-1_5x" fillColor="#016d03" :size="72" style="color:#6e6e6e; vertical-align: middle; margin: 6px; cursor: pointer"></delete>
          <resend-icon
              title=""
              v-if="buttonState !== 'none'"
              v-tooltip="'Zurückstellen'"
              class="icon-1_5x" fillColor="#016d03" :size="72" style="color:#6e6e6e; vertical-align: middle; margin: 6px; cursor: pointer"></resend-icon>
        </div>
      <b-col>
      </b-col>
      <!--b-button-group style="margin-right: 12px">
        <b-dropdown text="">
          <template #button-content="scope">
            <star-out-line
                v-if="isMarked === 0"
                title=""
                class="icon-1_5x icon-def-grey" fillColor="#383838" style="margin-left: -14px" :size="72"></star-out-line>
            <star-filled
                v-else-if="isMarked === 1"
                title=""
                class="icon-1_5x icon-def-grey" fillColor="#383838" style="margin-left: -14px" :size="72"></star-filled>
            <star-all
                v-else
                title=""
                class="icon-1_5x icon-def-grey" fillColor="#383838" style="margin-left: -14px" :size="72"></star-all>
            <span style="margin-left: 18px; margin-right: 10px; vertical-align: inherit" class="header-button">{{filterTitleIsMarked}}</span>
          </template>
          <b-dropdown-item @click="isMarked = -1; page = 0; queryData(false)">Alle</b-dropdown-item>
          <b-dropdown-item @click="isMarked = 0; page = 0; queryData(false)">Nicht markiert</b-dropdown-item>
          <b-dropdown-item @click="isMarked = 1; page = 0; queryData(false)">Markiert</b-dropdown-item>
        </b-dropdown>
      </b-button-group-->
      <div style="margin-right: 18px; display: table">
        <span style="display: table-cell; vertical-align: middle;">{{numberMessagesTitle}}</span>
      </div>
      <div style="margin-right: 15px; display: table">
        <ch-left
            @click="paginate(false)"
            title=""
            v-tooltip="'Neuere'"
            :class="'icon-1_5x no-select ' + (page === 0 ? 'ic-chevron inactive' : 'ic-chevron')"  :size="72"></ch-left>
        <ch-right
            @click="paginate(true)"
            title=""
            v-tooltip="'Ältere'"
            :class="'icon-1_5x no-select ' + (page * limit + limit >= numberMessages ? 'ic-chevron inactive' : 'ic-chevron')" :size="72" style="margin-left: 8px"></ch-right>
      </div>
    </b-row>
    <b-row class="custom-flex-1">
      <b-col sm="12">
        <b-table hover id="my-table" :items="items"
                 tbody-tr-class="small-padding test"
                 :fields="fields"
                 class="custom-auto-height"
                 thead-class=""
                 @row-hovered="onRowHover"
                 @row-unhovered="onRowUnhover"
                 style="cursor: pointer; overflow-y: hidden"
                 show-empty
                 @row-clicked="onRowClicked"
                 responsive
                 :sticky-header="true"
                 :no-border-collapse="true"
        >
          <template #HEAD[hover]="data">
            <div style="text-align: end">{{ data.label }}</div>
          </template>
          <template #empty="scope">
            <h4 class="no-items">{{ emptyMessage }}</h4>
          </template>
          <template #table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: calcSize(field.key) }"
            >
          </template>

          <template v-slot:cell(message_type)="data">
            <div :class=" data.item.hover ?  'inbox_icon icon-hover ' + getClassForInboxType(data.item.message_type) : 'inbox_icon ' + getClassForInboxType(data.item.message_type)">
              <administration-icon
                  v-if="data.item.message_type === 13"
                  title=""
                  v-tooltip="'Nachricht an Verwaltung'"
                  class="icon-1_5x inbox_icon_icon" fillColor="#ffffff" :size="72" ></administration-icon>
              <share-icon
                  v-else-if="data.item.message_type === 14 && data.item.topic_type === 'FO'"
                  title=""
                  v-tooltip="'Neue Nachricht'"
                  class="icon-1_5x inbox_icon_icon" fillColor="#ffffff" :size="72" ></share-icon>
              <message-icon
                  v-else-if="data.item.message_type === 14"
                  title=""
                  v-tooltip="'Neue Nachricht'"
                  class="icon-1_5x inbox_icon_icon" fillColor="#ffffff" :size="72" ></message-icon>
              <task-icon
                  v-else-if="data.item.message_type === 4"
                  title=""
                  v-tooltip="'Neue Nachricht'"
                  class="icon-1_5x inbox_icon_icon" fillColor="#ffffff" :size="72" ></task-icon>
              <task-int-icon
                  v-else-if="data.item.message_type === 5"
                  title=""
                  v-tooltip="'Neue Nachricht'"
                  class="icon-1_5x inbox_icon_icon" fillColor="#ffffff" :size="72" ></task-int-icon>
              <task-icon
                  v-else-if="data.item.message_type === 0 || data.item.message_type === 1 || data.item.message_type === 2
                  || data.item.message_type === 3 || data.item.message_type === 6 || data.item.message_type === 7
                  || data.item.message_type === 11 || data.item.message_type === 12 || data.item.message_type === 15"
                  title=""
                  v-tooltip="'Aufgabe'"
                  class="icon-1_5x inbox_icon_icon" fillColor="#ffffff" :size="72" ></task-icon>
              <request-icon
                  v-else-if="data.item.message_type > 15 && data.item.message_type < 22"
                  title=""
                  v-tooltip="'Urlaubs- / Überstundenanfrage'"
                  class="icon-1_5x inbox_icon_icon" fillColor="#ffffff" :size="72" ></request-icon>
              <euro-icon
                  v-else-if="data.item.message_type === 22"
                  title=""
                  v-tooltip="'Abrechnungsdatei'"
                  class="icon-1_5x inbox_icon_icon" fillColor="#ffffff" :size="72" ></euro-icon>
              <task-check-icon
                  v-else
                  title=""
                  v-tooltip="'Aufgabenzuteilung'"
                  class="icon-1_5x inbox_icon_icon" fillColor="#ffffff" :size="72" ></task-check-icon>
            </div>
          </template>

          <template v-slot:cell(selected)="data">
            <checkbox
                title=""
                @click.stop="toggleItemSelection(data.index)"
                v-tooltip="'Auswählen'"
                v-if="!data.item.is_selected" :class="data.item.hover ?  'icon-1_5x icon-def-grey icon-hover' : 'icon-1_5x icon-def-grey'" fillColor="#383838" :size="72" style="padding-top: 3px"></checkbox>
            <checkbox-checked @click.stop="toggleItemSelection(data.index)" v-tooltip="'Auswählen'" v-else class="icon-1_5x icon-def-grey icon-hover" :size="72" style="padding-top: 3px"></checkbox-checked>
            </template>
          <template v-slot:cell(is_marked)="data">
            <star-out-line
                title=""
                style="padding-top: 3px"
                @click.stop="handleChangeMessage([data.item.id], true, opMarked)"
                v-tooltip="'Nicht markiert'"
                v-if="!data.item.is_marked" :class="data.item.hover ?  'icon-1_5x icon-def-grey icon-hover' : 'icon-1_5x icon-def-grey'" fillColor="#383838" :size="72"></star-out-line>
            <star-filled
                title=""
                style="padding-top: 3px"
                @click.stop="handleChangeMessage([data.item.id], false, opMarked)"
                v-tooltip="'Markiert'"
                v-else  :class="data.item.hover ?  'icon-1_5x icon-def-yellow icon-hover' : 'icon-1_5x icon-def-yellow'" fillColor="#016d03" :size="72" ></star-filled>
          </template>
          <template v-slot:cell(task_number)="data">
            <span :class="data.item.is_read ? 'message-subject' : 'message-subject not-read'">{{data.item.task_number}}</span>
          </template>
          <template v-slot:cell(due_date)="data">
            <span :class="data.item.is_read ? 'message-subject' : 'message-subject not-read'">{{formateDueDate(data.item.due_date)}}</span>
          </template>
          <template v-slot:cell(has_attachments)="data">
            <has-attachment
                title=""
                v-tooltip="'Anhänge vorhanden'"
                v-if="data.item.has_attachments"  :class="data.item.hover ?  'icon-1_5x icon-def-grey icon-hover' : 'icon-1_5x icon-def-grey'" fillColor="#383838" :size="72" ></has-attachment>
            <div v-else></div>
          </template>
          <template v-slot:cell(has_gps)="data">
            <has-coordiantes
                title=""
                v-tooltip="'Koordinaten vorhanden'"
                v-if="data.item.has_coordinates"  :class="data.item.hover ?  'icon-1_5x icon-def-grey icon-hover' : 'icon-1_5x icon-def-grey'" fillColor="#383838" :size="72" ></has-coordiantes>
            <div v-else></div>
          </template>
          <template v-slot:cell(from)="data">
            <span style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis" :class="data.item.is_read ? 'message-subject' : 'message-subject not-read'">{{data.value}}</span>
          </template>
          <template v-slot:cell(body)="data">
            <span :class="data.item.is_read ? 'message-subject' : 'message-subject not-read'">{{data.item.subject}}</span>
            <span :class="data.item.is_read ? 'message-body' : 'message-body not-read'"> - {{data.item.body}}</span>
            <div style="max-width: 40vw">
              <span class="message-memo" style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: block">{{data.item.memo}}</span>
            </div>
          </template>
          <template v-slot:cell(hover)="data">
            <span v-if="!data.item.hover" :class="data.item.is_read ? 'message-subject' : 'message-subject not-read'" style="float: right; ">{{displayUpdateDate(data.item.create_date)}}</span>
            <set-read
                title=""
                @click.stop="handleChangeMessage([data.item.id], true, opRead)"
                v-if="data.item.hover && !data.item.is_read"
                v-tooltip="'Als gelesen markieren'"
                class="icon-1_5x" fillColor="#016d03" :size="72" style="color:#6e6e6e; float: right; cursor: pointer; padding-top: 3px"></set-read>
            <set-unread
                title=""
                @click.stop="handleChangeMessage([data.item.id], false, opRead)"
                v-if="data.item.hover && data.item.is_read"
                v-tooltip="'Als ungelesen markieren'"
                class="icon-1_5x" fillColor="#016d03" :size="72" style="color:#6e6e6e; float: right; cursor: pointer;padding-top: 3px"></set-unread>
            <delete
                title=""
                @click.stop="handleChangeMessage([data.item.id], true, opDelete)"
                v-if="data.item.hover"
                v-tooltip="'Löschen'"
                class="icon-1_5x" fillColor="#016d03" :size="72" style="color:#6e6e6e; float: right; margin-right: 12px; cursor: pointer;padding-top: 3px"></delete>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL} from "../../shared/utils";
import StarOutLine from 'vue-material-design-icons/StarOutline';
import StarFilled from 'vue-material-design-icons/Star';
import StarAll from 'vue-material-design-icons/StarHalf';
import Checkbox from 'vue-material-design-icons/CheckboxBlankOutline';
import CheckboxChecked from 'vue-material-design-icons/CheckBoxOutline';
import CheckboxSome from 'vue-material-design-icons/MinusBoxOutline';
import Delete from 'vue-material-design-icons/TrashCanOutline';
import SetRead from 'vue-material-design-icons/EmailOpenOutline';
import SetUnread from 'vue-material-design-icons/EmailOutline';
import Refresh from 'vue-material-design-icons/Refresh';
import ChLeft from 'vue-material-design-icons/ChevronLeft';
import ChRight from 'vue-material-design-icons/ChevronRight';
import AllMail from 'vue-material-design-icons/EmailMultipleOutline';
import HasAttachment from 'vue-material-design-icons/Attachment.vue';
import HasCoordiantes from 'vue-material-design-icons/Map.vue';
import ResendIcon from 'vue-material-design-icons/ClockOutline.vue';
import AdministrationIcon from 'vue-material-design-icons/Domain.vue';
import MessageIcon from 'vue-material-design-icons/Message.vue';
import TaskIcon from 'vue-material-design-icons/ClipboardText.vue';
import TaskIntIcon from 'vue-material-design-icons/ClipboardAccount.vue';
import TaskCheckIcon from 'vue-material-design-icons/ClipboardCheck.vue';
import ShareIcon from 'vue-material-design-icons/ReplyAll.vue';
import RequestIcon from 'vue-material-design-icons/CalendarQuestion.vue';
import EuroIcon from 'vue-material-design-icons/CurrencyEur.vue';

import {decryptInbox, encryptAES} from "../../shared/crypto";

const TaskNew = 0;
const TaskAccepted = 1;
const TaskFinished = 2;
const TaskSettled = 3;
const TaskMessage = 4;
const TaskMessageInternal = 5;
const TaskDelete = 6;
const TaskRejected = 7;
const TaskTodoNew = 8;
const TaskTodoRemoved = 9;
const TaskTodoFinished = 10;
const TaskSammelrechnung = 11;
const TaskMaengelMelder = 12;
const MessageAdministration = 13;
const MessageGeneral = 14;
const MessageResultingTasks = 15;

const MessageTypeHolidayRequest = 16;
const MessageTypeHolidayAccepted = 17;
const MessageTypeHolidayRejected = 18;
const MessageTypeOvertimeRequest = 19;
const MessageTypeOvertimeAccepted = 20;
const MessageTypeOvertimeRejected = 21;
const MessageTypeInvoiceApiReady = 22;

export default {
  name: "Inbox",
  components: {
    StarOutLine, StarFilled, Checkbox,
    CheckboxChecked, Delete, SetRead,
    SetUnread, CheckboxSome, Refresh,
    ChLeft, ChRight, AllMail, StarAll, HasAttachment,
    ResendIcon, AdministrationIcon, TaskIcon, TaskCheckIcon,
    TaskIntIcon, MessageIcon, HasCoordiantes, ShareIcon, RequestIcon, EuroIcon
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  data() {
    return {
      myUser: '',
      loader: undefined,
      isRead: -1,
      isMarked: -1,
      page: 0,
      items: [],
      limit: 20,
      numberMessages: 0,
      fields: [
        {key: 'message_type', label: ''},
          //{key: 'selected', label: ''},
        //{key: 'is_marked', label: ''},
        {key: 'body', label: 'Betreff'},
        //{key: 'task_number', label: 'Nummer'},
        {key: 'has_attachments', label: ''},
        {key: 'has_gps', label: ''},
        {key: 'from', label: 'Absender', formatter: (value, key, item) => {
            if (item === null) {
              return null;
            }
            if (value === "Bauhof") {
              return "Bauhof"
            } else if (value === "ft") {
              return "FastTask"
            } else if (value === "sp") {
              return "Spielplatzkontrolle"
            } else if (value === "kl") {
              return "GPS-Nachweis"
            }
            let res = JSON.parse(sessionStorage.getItem(value));
            if (res === null) {
              return value;
            }
            return res.first_name + " " + res.surname;
          }},
        {key: 'due_date', label: 'Ziel'},
        {key: 'hover', label: 'erhalten am'},
      ],
      opMarked: "marked",
      opRead: "read",
      opDelete: "delete",
      timer: null,
      animate: false,
      clickedItem: null,
    }
  },
  created() {
    //this.showLoader();
    this.myUser = this.$cookies.get("ps_user_id");
    this.queryData(false);
  },
  computed: {
    selectedItems() {
      let selected = [];
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].is_selected) {
          selected.push(this.items[i].id);
        }
      }
      return selected;
    },
    emptyMessage() {
      if (this.isRead === -1 && this.isMarked === -1) {
        return "Sie haben keine Nachrichten im Posteingang.";
      } else if (this.isRead === -1) {
        let res = "Sie haben keine "
        if (this.isMarked === 0) {
          res += "unmarkierte "
        } else {
          res += "markierte "
        }
        return res + "Nachrichten im Posteingang."
      } else if (this.isMarked === -1) {
        let res = "Sie haben keine "
        if (this.isRead === 0) {
          res += "ungelesenen "
        } else {
          res += "gelesenen "
        }
        return res + "Nachrichten im Posteingang."
      } else {
        let res = "Sie haben keine "
        if (this.isRead === 0) {
          res += "ungelesenen und "
        } else {
          res += "gelesenen und "
        }
        if (this.isMarked === 0) {
          res += "unmarkierte "
        } else {
          res += "markierte "
        }
        return res + "Nachrichten im Posteingang."

      }
    },
    buttonState() {
      let numSelected = 0;
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].is_selected) {
          numSelected++;
        }
      }
      if (numSelected === 0) {
        return "none";
      } else if (numSelected === this.items.length) {
        return "all";
      } else {
        return "some"
      }
    },
    filterTitleIsRead() {
      if (this.isRead === -1) {
        return "Gelesen / Ungelesen"
      } else if (this.isRead === 0) {
        return "Ungelesen"
      } else {
        return "Gelesen"
      }
    },
    filterTitleIsMarked() {
      if (this.isMarked === -1) {
        return "Markiert / Nicht markiert"
      } else if (this.isMarked === 0) {
        return "Nicht markiert"
      } else {
        return "Markiert"
      }
    },
    numberMessagesTitle() {
      if (this.numberMessages <= 1) {
        return "" + this.numberMessages + " von " + this.numberMessages;
      }
      return "" + (this.page * this.limit + 1) + " - " + (this.page * this.limit + this.items.length) + " von " + this.numberMessages;

    }
  },
  methods: {
    getClassForInboxType(messageType) {
      switch (messageType) {
        case MessageAdministration:
          return "inbox_admin_color";
        case MessageGeneral:
        case TaskMessageInternal:
        case TaskMessage:
          return "inbox_chat_color";
        case TaskAccepted:
          case TaskDelete:
        case TaskFinished:
        case TaskMaengelMelder:
        case TaskNew:
        case TaskRejected:
        case TaskSammelrechnung:
        case TaskSettled:
        case MessageTypeInvoiceApiReady:
          return "inbox_task_color";
        case MessageTypeHolidayRequest:
        case MessageTypeHolidayAccepted:
        case MessageTypeHolidayRejected:
        case MessageTypeOvertimeRequest:
        case MessageTypeOvertimeAccepted:
        case MessageTypeOvertimeRejected:
          return "inbox_request_color";
      }
      return "";
    },
    formateDueDate(value) {
      if (!value) {
        return "";
      }
      let d = new Date(value.replace('Z',''));
      let res =  ("0" + d.getDate()).slice(-2)   + "." +
          ("0" + (d.getMonth()+1)).slice(-2) + "." + d.getFullYear();
      return res;
    },
    manualRefresh(){
      this.showLoader();
      this.queryData(true);
    },
    onRowClicked(item) {
      this.clickedItem = item;
      this.$http.post(
          Server_URL+'/auftragsbuch/inbox/read/' + item.id
      ).then(this.responseOkClicked, this.responseError)
    },
    paginate(up) {
      if (this.page === 0 && !up) {
        return
      } else if ((this.page * this.limit + this.limit) >= this.numberMessages && up) {
        return;
      }
      this.page = this.page + (up ? 1 : -1);
      this.queryData(false);
    },
    selectState(state) {
      if (state === 'all' || state === 'none') {
        let select = state === 'all';
        for (let i = 0; i < this.items.length; i++) {
          this.items[i].is_selected = select;
          this.items[i]._rowVariant = select ? "selected" : null;

        }
        return
      } else if (state === 'read' || state === 'unread') {
        let condition = state === 'read';
        for (let i = 0; i < this.items.length; i++) {
          this.items[i].is_selected = condition === this.items[i].is_read;
          this.items[i]._rowVariant = condition === this.items[i].is_read ? "selected" : null;

        }
      } else {
        let condition = state === 'marked';
        for (let i = 0; i < this.items.length; i++) {
          this.items[i].is_selected = condition === this.items[i].is_marked;
          this.items[i]._rowVariant = condition === this.items[i].is_marked ? "selected" : null;

        }
      }
    },
    onRowHover(item, index) {
      this.items[index].hover = true;
    },
    onRowUnhover(item, index) {
      this.items[index].hover = false;
    },
    calcSize(field) {
      if (field === 'selected' || field === 'is_marked' || field === 'has_attachments' || field === 'has_gps' || field === 'message_type') {
        return '36px'
      } else if (field === 'task_number' || field === 'due_date') {
        return '200px'
      } else if (field === 'from') {
        return '200px'
      } else if (field === 'hover') {
        return '200px'
      } else {
        return '1500px'
      }
    },
    displayUpdateDate(updateDate) {
      let d = new Date(updateDate.replace('Z',''));
      let startToday = new Date();
      startToday.setHours(0, 0, 0)
      if (startToday < d) {
        let res =  ("0" + d.getHours()).slice(-2)   + ":" +
        ("0" + d.getMinutes()).slice(-2);
        return res;
      } else {
        let res =  ("0" + d.getDate()).slice(-2)   + "." +
            ("0" + (d.getMonth()+1)).slice(-2) + "." + d.getFullYear();
        return res;
      }
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkClicked(response) {
      if (this.clickedItem && this.clickedItem.message_type === MessageTypeInvoiceApiReady) {
        this.$router.push("/auswertung/bills");
        return;
      } else if (this.clickedItem && this.clickedItem.message_type > 15 && this.clickedItem.message_type < 22) {
        // todo
        return;
      } else if (this.clickedItem && this.clickedItem.message_type !== MessageAdministration && this.clickedItem.message_type !== MessageGeneral) {
        // todo handle the task if type is TaskMessageInternal -> eg. strip -int of id
        let route =  "/auftraege/auftrag/" + this.clickedItem.topic_id
        if (this.clickedItem.message_type === TaskMessage || this.clickedItem.message_type === TaskMessageInternal) {
          route += "?open_chat=" + (this.clickedItem.message_type === TaskMessage ? "task" : "int");
        }
        this.$router.push(route);
      } else {
        this.$router.push("/chats/chat?room_id=" + this.clickedItem.topic_id);
      }
    },
    responseOkGet(response) {
      if (response.status === 200) {
        this.limit = response.body.limit;
        this.numberMessages = response.body.number_messages;
        if (sessionStorage.getItem("aes") !== null) {
          decryptInbox(sessionStorage.getItem("aes"), response.body.messages).then(res => {
            // formate chat messages
            for (let i = 0; i < res.length; i++) {
              let cur = res[i];
              if (cur.message_type === 14 || cur.message_type === 4 || cur.message_type === 5) {
                cur.memo = cur.body;
                cur.body = cur.topic_name;
                if (cur.topic_id.includes(this.myUser)) {
                  let res = JSON.parse(sessionStorage.getItem(cur.from));
                  if (res === null) {
                    cur.body = cur.from;
                  }
                  cur.body =  res.first_name + " " + res.surname;
                }
                res[i] = cur;
              }
            }
            if (!this.animate) {
              this.items = res;
            } else {
              // remove all existing rows form new items
              let newRes = [];
              for (let i = 0; i < res.length; i++) {
                let item = res[i];
                let found = false;
                for (let j = 0; j < this.items.length; j++) {
                  let itemOld = this.items[j];
                  if (itemOld.id === item.id && itemOld.update_date === item.update_date) {
                    found = true;
                    break
                  }
                }
                if (!found) {
                  newRes.push(item);
                }
              }
              // remove all existing rows from old items
              let oldRes = [];
              for (let i = 0; i < this.items.length; i++) {
                let oldItem = this.items[i];
                let found = false;
                for (let j = 0; j < res.length; j++) {
                  let item = res[j];
                  if (oldItem.id === item.id && oldItem.update_date === item.update_date) {
                    found = true;
                    break
                  }
                }
                if (found) {
                  oldRes.push(oldItem);
                }
              }
              res = newRes.concat(oldRes).sort((a,b) => (a.create_date < b.create_date) ? 1 : ((b.create_date < a.create_date) ? -1 : 0))
              this.items = res;
            }
            this.hideLoader();
          }).catch(res => {
            console.log(res);
          })
        }
        clearInterval(this.timer)
        if (this.page === 0) {
          this.timer = setInterval(this.refresh, 10000)
        }
      } else {
          this.hideLoader();
        window.location = Redirect_500;
      }
    },
    refresh() {
      if (this.page === 0 && this.selectedItems.length === 0 && this.loader === undefined) {
        this.queryData(true);
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        console.log(response);
        //window.location = Redirect_500;
      }
    },
    queryData(animate) {
      this.animate = animate;
      this.$http.get(
          Server_URL+'/auftragsbuch/inbox'+
          "?is_read="+this.isRead+
          "&is_marked="+this.isMarked+
          "&page="+this.page
      ).then(this.responseOkGet, this.responseError)
    },
    toggleItemSelection(index) {
      this.items[index].is_selected = !this.items[index].is_selected;
      this.items[index]._rowVariant = this.items[index].is_selected ? "selected" : null;
    },
    handleChangeMessage(messageIds, isSet, opType) {
      if (messageIds.length === 1) {
        this.animate = true;
      } else {
        this.showLoader();
      }
      let req = {};
      switch (opType) {
        case this.opRead:
          req = {
            message_ids: messageIds,
            is_read: isSet,
          }
          break;
        case this.opMarked:
          req = {
            message_ids: messageIds,
            is_marked: isSet,
          }
          break;
        case this.opDelete:
          req = messageIds;
          break;
        default:
          return;
      }
      this.$http.post(
          Server_URL+'/auftragsbuch/inbox/' + opType+
          "?is_read="+this.isRead+
          "&is_marked="+this.isMarked+
          "&page="+this.page, req
      ).then(this.responseOkGet, this.responseError)
    },
  },
}
</script>

<style scoped>

  ::v-deep tr.small-padding > td {
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
    padding-bottom: 0.15rem !important;
    padding-top: 0.15rem !important;
  }

  .message-subject {
    -webkit-font-smoothing: antialiased;
    font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
    font-size: .875rem;
    line-height: 30px;
    font-weight: normal;
    color: #202124;
    vertical-align: sub;
  }

  .message-body {
    -webkit-font-smoothing: antialiased;
    font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
    font-size: .875rem;
    letter-spacing: normal;
    color: #383838;
    font-weight: normal;
    vertical-align: sub;
  }

  .message-memo {
    -webkit-font-smoothing: antialiased;
    font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
    font-size: .875rem;
    letter-spacing: normal;
    color: #5f6368;
    font-weight: normal;
    vertical-align: sub;
  }

  .message-subject.not-read {
    font-weight: 700;
    letter-spacing: 0.05em;
  }
  .message-body.not-read {
    font-weight: 700;
    letter-spacing: 0.05em;
  }

  .header-button {
    -webkit-font-smoothing: antialiased;
    font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
    font-size: .875rem;
    letter-spacing: normal;
    color: #5f6368;
    font-weight: normal;
    vertical-align: sub;
  }

  .icon-def-grey {
    color: #5f6368;
  }

  .icon-def-grey.icon-hover {
    color: #202124;
  }

  .icon-def-yellow {
    color: #ffb900;
  }

  .icon-def-yellow.icon-hover {
    color: #F4B400;
  }

  .no-items {
    -webkit-font-smoothing: antialiased;
    font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
    font-size: 1.2rem;
    line-height: 20px;
    font-weight: normal;
    color: #333334;
    text-align: center;
  }

  ::v-deep .table-selected {
    background-color: #C2DBFF !important;
  }

  ::v-deep .btn-secondary {
    background: white;
  }

  ::v-deep  .test:hover {
    -webkit-box-shadow: 0px 3px 2px 0px rgba(0,0,0,0.31);
    box-shadow: 0px 3px 2px 0px rgba(0,0,0,0.31);
    border-bottom: 1px solid rgba(42, 51, 65, 0.13);
    border-top: 1px solid rgba(42, 51, 65, 0.13);
    z-index: 1;
  }

  ::v-deep .table-hover tbody tr:hover {
    background-color: white;
  }

  ::v-deep .material-design-icon > .material-design-icon__svg {
    bottom: inherit;
  }

  .ic-chevron {
    color:#6e6e6e;
    vertical-align: middle;
    cursor: pointer;
    margin-top: 6px;
    margin-bottom: 6px
  }
  .ic-chevron.inactive {
    color: #919191;
    cursor: default;
  }

  .inbox_icon {
    height: 35px;
    border-radius: 24px;
    width: 35px;
    background: #E57373;
  }
  .inbox_icon.icon-hover {
    box-shadow: 1px 1px 6px grey;
  }


  .inbox_admin_color {
    background: #53A056 !important;
  }
  .inbox_chat_color {
    background: #428BCA !important;
  }
  .inbox_task_color {
    background: #F57F17 !important;
  }

  .inbox_request_color {
    background: #e5fa31 !important;
  }

  .inbox_icon_icon {
    margin: 5.5px;
    color: white;
  }


</style>

<style>

.no-display {
  display: none;
}

.no-select{
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.max-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
  float: right;
}

</style>
